/**
 * Block: hero, script.
 *
 * Enqueued in editor and front end.
 */

import Swiper, { Autoplay, EffectFade } from 'swiper';

function init() {
	const swiper = new Swiper( '.wp-block-lakecountyohio-hero__slideshow', {
		modules: [ Autoplay, EffectFade ],
		autoplay: {
			delay: 6000,
		},
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 3000,
		/*
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		*/
	} );
}

document.addEventListener('DOMContentLoaded', () => {
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=lakecountyohio/hero', init );
	}
	else {
		init();
	}
} );
